<template>
  <div>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="margin-top: 20px">
          <el-table-column type="index" prop="序号"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" width="70"></el-table-column>
          <el-table-column prop="OP_COUNT" label="生产数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.OP_COUNT" :disabled="disabled"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="OP_PRICE" label="价格" width="150"></el-table-column>
          <el-table-column prop="MARKET_PRICE" label="市场价">
            <template slot-scope="scope">
              <el-input v-model="scope.row.MARKET_PRICE" :disabled="disabled"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="OP_FEE" label="金额" width="150"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PRODUCT_COMMENT" :disabled="disabled"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="生产日期" width="250">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.PRODUCTION_DATE" type="date" placeholder="生产日期" value-format="yyyy-MM-dd"
                :clearable="true" size="small" :disabled="disabled"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="库位" width="250" v-if="WAREHOUSE_MODE == 2 && !disabled">
            <template slot-scope="scope">
              <el-select v-model="scope.row.LOCATION_ID" placeholder="请选择" clearable size="small" :disabled="disabled">
                <el-option v-for="item in locationList" :label="item.CODE" :value="item.ID" :key="item.ID"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="SHELF_LIFE" label="保质期" width="70">
          </el-table-column>
        </el-table>
      </el-col>
      <el-col>
        <el-button size="medium" @click="submitEdit" style="margin-top: 20px;float: right" v-show="pickStatus == 2">确认修改</el-button>
        <el-button size="medium" @click="enterWare" style="margin-top:20px;margin-right: 10px;float: right" v-show="pickStatus == 2">
          确认入库</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { openResultFun, editFun, enterWareFun } from 'api/proDepartment';
import { queryPosition } from '@/assets/api/warehouseManager';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      tableData: [],
      departmentList: [],
      pickerOptions: [],
      pickStatus: 0,
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
      locationList: [],
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
    };
  },
  computed: {
    disabled() {
      return this.pickStatus != 2;
    },
  },
  created() {
    this.queryData();
    this.pickStatus = sessionStorage.getItem('pickStatus');
    this.queryLocation();
  },
  methods: {
    queryData() {
      const params = {
        INNER_DETAIL_ID: sessionStorage.getItem('innerId'),
      };
      openResultFun(params).then((res) => {
        if (res[0]) {
          this.tableData = res.map((item) => Object.assign(
            item,
            { PRODUCTION_DATE: date(new Date(), '%F') },
            { SHELF_LIFE: item.QGP + this.QGP_TIME_TYPE[item.QGP_TIME_TYPE] },
          ));
          console.log(res);
          this.addFormVisible = false;
          this.addForm = {};
        } else {
          this.tableData = [];
          this.addFormVisible = false;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitEdit(row) {
      let submitArr = [];
      submitArr = this.tableData.map((item) => ({
        OP_CODE: item.OP_CODE,
        OP_COUNT: item.OP_COUNT,
        MARKET_PRICE: item.MARKET_PRICE || 0,
        PRODUCT_COMMENT: item.PRODUCT_COMMENT,
        OP_FEE: item.OP_FEE,
      }));
      const params = {
        INNER_DETAIL_ID: sessionStorage.getItem('innerId'),
        ORDER_ID: Number(sessionStorage.getItem('orderID')),
        PRODUCT_ARRAY: submitArr,
      };
      editFun(params).then((res) => {
        this.$message.show({ text: '修改成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    enterWare() {
      this.tableData.map((item) => {
        let submitArr = [];
        submitArr = this.tableData.map((itemTwo) => ({
          INNER_CODE: itemTwo.OP_CODE,
          PRODUCT_PRICE: Number(itemTwo.OP_PRICE),
          PRODUCT_COUNT: Number(itemTwo.OP_COUNT),
          PRODUCTION_DATE: itemTwo.PRODUCTION_DATE || '',
          ORDER_DETAIL_ID: Number(itemTwo.ID),
          LOCATION_ID: itemTwo.LOCATION_ID,
        }));
        const params = {
          INNER_DETAIL_ID: sessionStorage.getItem('innerId'),
          ORDER_ID: Number(sessionStorage.getItem('orderID')),
          PRODUCT_ARRAY: submitArr,
        };
        enterWareFun(params).then((res) => {
          this.$message.show({ text: '入库成功', type: 'success' });
          this.pickStatus = 3;
          sessionStorage.setItem('pickStatus', this.pickStatus);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      });
    },
    queryLocation() {
      queryPosition()
        .then((result) => {
          if (result.length !== 0) {
            this.locationList = result.map((item) => Object.assign(item, { CODE: item.CODE.toString() }));
          } else {
            this.locationList = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/proPickingResult.vue